<div class="card card-default" ng-cloak *ngIf="!redirectToFirst">

    <div class="panel-heading modal-header panel-header-padding panel-header-radius">

        <div ngbTooltip="Return to Dashboard" class="card-caption pull-left"><a (click)="showDashboard()"
                *ngIf="project">{{project.name}} Scenarios</a></div>
        <div class="float-end">
            <button ngbTooltip="Return to Dashboard" class="btn btn-sm sk-btn-light float-end" type="button"
                (click)="showDashboard()">Dashboard</button>

            <button ngbTooltip="Import Scenario" class="btn btn-sm sk-btn-light float-end" type="button"
                (click)="importScenario()">Import Scenario</button>
            
            <ngb-pagination *ngIf="data" (pageChange)="pageChanged($event)" size="sm" [(page)]="data.currentPage"
                class="sk-pagination me-2 float-end" style="margin-right: 10px;" [pageSize]="data.pageSize"
                [collectionSize]="data.rowCount" [maxSize]="5" [rotate]="true" [boundaryLinks]="true">
            </ngb-pagination>

        </div>

    </div>

    <div class="panel-body panel-body-padding">
        <form [formGroup]="modalForm">
            <div style="overflow-x: auto;">
                <table class="table table-hover">
                    <thead>

                        <tr>
                            <th></th>
                            <th>
                                <a (click)="changeSort('ExportedScenarioName')" class="sk-link">
                                    Scenario&nbsp;Name
                                    <span *ngIf="filter.sort == 'ExportedScenarioName' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedScenarioName' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('ExportedScenarioLabel')" class="sk-link">
                                    Scenario&nbsp;Label
                                    <span *ngIf="filter.sort == 'ExportedScenarioLabel' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedScenarioLabel' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('ExportedScenarioId')" class="sk-link">
                                    Scenario&nbsp;Id
                                    <span *ngIf="filter.sort == 'ExportedScenarioId' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedScenarioId' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('ExportedScenarioInstance')" class="sk-link">
                                    Export&nbsp;Id
                                    <span *ngIf="filter.sort == 'ExportedScenarioInstance' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedScenarioInstance' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('ExportedByUser')" class="sk-link">
                                    Exported&nbsp;By
                                    <span *ngIf="filter.sort == 'ExportedByUser' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedByUser' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('ExportedDate')" class="sk-link">
                                    Exported&nbsp;On
                                    <span *ngIf="filter.sort == 'ExportedDate' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'ExportedDate' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th *ngIf="isShowDeleted">
                                <a (click)="changeSort('DeletedByUser')" class="sk-link">
                                    Deleted&nbsp;By
                                    <span *ngIf="filter.sort == 'DeletedByUser' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'DeletedByUser' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th *ngIf="isShowDeleted">
                                <a (click)="changeSort('DeletedDate')" class="sk-link">
                                    Deleted&nbsp;On
                                    <span *ngIf="filter.sort == 'DeletedDate' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'DeletedDate' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th>
                                <a (click)="changeSort('LastUpdatedDate')" class="sk-link">
                                    Last&nbsp;Modified&nbsp;On
                                    <span *ngIf="filter.sort == 'LastUpdatedDate' && filter.ascending"
                                        class="bi bi-caret-down"></span>
                                    <span *ngIf="filter.sort == 'LastUpdatedDate' && !filter.ascending"
                                        class="bi bi-caret-up"></span>
                                </a>
                            </th>
                            <th *ngIf="project&&project.keyPerformanceIndicator1Label" tooltip-append-to-body="true"
                                ngbTooltip="{{project.keyPerformanceIndicator1Label}}">
                                {{project.keyPerformanceIndicator1Label
                                | elipsis: 30}}</th>
                            <th *ngIf="project&&project.keyPerformanceIndicator2Label" tooltip-append-to-body="true"
                                ngbTooltip="{{project.keyPerformanceIndicator2Label}}">
                                {{project.keyPerformanceIndicator2Label
                                | elipsis: 30}}</th>
                            <th *ngIf="project&&project.keyPerformanceIndicator3Label" tooltip-append-to-body="true"
                                ngbTooltip="{{project.keyPerformanceIndicator3Label}}">
                                {{project.keyPerformanceIndicator3Label
                                | elipsis: 30}}</th>
                            <th *ngIf="project&&project.keyPerformanceIndicator4Label" tooltip-append-to-body="true"
                                ngbTooltip="{{project.keyPerformanceIndicator4Label}}">
                                {{project.keyPerformanceIndicator4Label
                                | elipsis: 30}}</th>
                            <th *ngIf="project&&project.keyPerformanceIndicator5Label" tooltip-append-to-body="true"
                                ngbTooltip="{{project.keyPerformanceIndicator5Label}}">
                                {{project.keyPerformanceIndicator5Label
                                | elipsis: 30}}</th>
                            <th style="min-width:70px">Notes</th>
                            <th>Documents</th>
                            
                        </tr>
                        <tr class="hide-when-printed">
                            <th style="padding-bottom:15px"><i class="bi bi-search text-dimmed"></i></th>
                            <th style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="exportedScenarioName" [(ngModel)]="filter.exportedScenarioName" />
                            </th>
                            <th style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="exportedScenarioLabel"
                                    [(ngModel)]="filter.exportedScenarioLabel" />
                            </th>
                            <th style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="exportedScenarioId" [(ngModel)]="filter.exportedScenarioId" />
                            </th>
                            <th style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="exportedScenarioInstance"
                                    [(ngModel)]="filter.exportedScenarioInstance" />
                            </th>
                            <th style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="exportedByUser" [(ngModel)]="filter.exportedByUser" />
                            </th>
                            <th style="font-weight: normal;">

                                <!--sk-flatpickr-date (dateChanged)="setExportedDate($event);"></sk-flatpickr-date>-->
                                <sk-date (dateChanged)="setExportedDate($event);"></sk-date>

                            </th>
                            <th *ngIf="isShowDeleted" style="font-weight: normal;">
                                <input type="text" class="form-control input-xs simplebox"
                                    formControlName="deletedByUser" [(ngModel)]="filter.deletedByUser" />
                            </th>
                            <th *ngIf="isShowDeleted" style="font-weight: normal;">
                                <!--<sk-flatpickr-date (dateChanged)="setDeletedDate($event);"></sk-flatpickr-date>-->
                                <sk-date (dateChanged)="setDeletedDate($event);"></sk-date>
                            </th>
                            <th style="font-weight: normal;">
                                <!--<sk-flatpickr-date (dateChanged)="setLastUpdatedDate($event);"></sk-flatpickr-date>-->
                                <sk-date (dateChanged)="setLastUpdatedDate($event);"></sk-date>
                            </th>
                            <th *ngIf="project&&project.keyPerformanceIndicator1Label"></th>
                            <th *ngIf="project&&project.keyPerformanceIndicator2Label"></th>
                            <th *ngIf="project&&project.keyPerformanceIndicator3Label"></th>
                            <th *ngIf="project&&project.keyPerformanceIndicator4Label"></th>
                            <th *ngIf="project&&project.keyPerformanceIndicator5Label"></th>
                            <th></th>
                            <th></th>
                        </tr>

                    </thead>

                    <tbody *ngIf="data">
                        <tr *ngFor="let item of data.projectScenarioDTO | filter: deletedFilter: filterChanged"
                            class="clickable" (click)="showRow(item)">
                            
                            <td></td>
                            <td>{{item.exportedScenarioName}}</td>
                            <td>{{item.exportedScenarioLabel}}</td>
                            <td>S{{('00000' + item.exportedScenarioId).slice(-6)}}</td>
                            <td>E{{('00000' + item.projectScenarioId).slice(-6)}}</td>
                            <td>{{item.exportedByUser}}</td>
                            <td>{{item.exportedDate | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td *ngIf="isShowDeleted">{{item.deletedByUser}}</td>
                            <td *ngIf="isShowDeleted">{{item.deletedDate | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td>{{item.lastUpdatedDate | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td *ngIf="project&&project.keyPerformanceIndicator1Label">{{item.keyPerformanceIndicator1}}
                            </td>
                            <td *ngIf="project&&project.keyPerformanceIndicator2Label">{{item.keyPerformanceIndicator2}}
                            </td>
                            <td *ngIf="project&&project.keyPerformanceIndicator3Label">{{item.keyPerformanceIndicator3}}
                            </td>
                            <td *ngIf="project&&project.keyPerformanceIndicator4Label">{{item.keyPerformanceIndicator4}}
                            </td>
                            <td *ngIf="project&&project.keyPerformanceIndicator5Label">{{item.keyPerformanceIndicator5}}
                            </td>
                            
                            <td style="padding: 0;padding-left:15px">
                                
                                <span *ngIf="countNotes(item.notes) > 0" style="color: #00529B">
                                    <i style="font-size: 44px;" class="bi bi-file-earmark-text"></i>
                                    <span
                                        style="position:relative; margin-right:5px; width:auto; padding: 1px 6px; border-radius: 50%; background-color: white; color: #00529B; border-color: #00529B; border-width:2px; border-style: solid; font-size: 12px; margin-top: 35px; margin-left:-20px">{{countNotes(item.notes)}}
                                    </span>
                                </span>
                            </td>
                            <td style="padding: 0;padding-left:27px">
                                
                                <span *ngIf="countDocuments(item.notes) > 0" style="color: #00529B">
                                    <i style="font-size: 44px;" class="bi bi-paperclip"></i>
                                    <span
                                        style="position:relative; margin-right:5px; width:auto; padding: 1px 6px; border-radius: 50%; background-color: white; color: #00529B; border-color: #00529B; border-width:2px; border-style: solid; font-size: 12px; margin-top: 35px; margin-left:-20px">{{countDocuments(item.notes)}}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
        <a class="float-end" permission="show-deleted-scenarios" (click)="showDeleted()"><small class="sk-link"
                *ngIf="isShowDeleted">hide deleted</small><small *ngIf="!isShowDeleted" class="sk-link">show
                deleted</small></a>

    </div>

</div>